import React from 'react';
import _ from 'lodash';
import { ManualImgix } from 'shared/components/imgix';
import styled from 'styled-components';
import { Description } from '../../typography';

export default function AboutTheBrand({ brand, isLastSection }) {
  const imgixParams = {
    trim: `color`,
    'trim-color': `FFFFFF`,
    fit: `clip`,
    h: 130,
    w: 207,
  };

  const descriptionParagraphs = _.map(_.split(brand?.description ?? '', '\n'), (line) => (
    <p>{_.isEmpty(line) ? ' ' : line}</p>
  ));

  return (
    <Container>
      {brand.imageUrl && (
        <ManualImgix src={brand.imageUrl} imgixParams={imgixParams} alt={brand.name ? `${brand.name} Logo` : null} />
      )}

      {brand.description && (
        <StyledDescription isLastSection={isLastSection}>{descriptionParagraphs}</StyledDescription>
      )}
    </Container>
  );
}

const Container = styled.div`
  > img {
    display: block;
    margin-bottom: 21px;
    max-width: 207px;
  }
`;

const StyledDescription = styled(Description)`
  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: 12px;
  }
  p {
    margin-bottom: ${({ isLastSection }) => (isLastSection ? `0px` : `22px`)};
  }
`;
